import React from "react";

const UsageDashboard = ({ usage, isAnonymous }) => {
  if (!usage) return null;

  const dailyPct = Math.min((usage.today / usage.dailyLimit) * 100, 100);
  // const weeklyPct = Math.min((usage.week / usage.weeklyLimit) * 100, 100);
  const overLimit =
    usage.today >= usage.dailyLimit
    // || usage.week >= usage.weeklyLimit
    ;

  return (
    <div style={{ marginTop: "2rem", padding: "0.75rem", fontSize: "0.85rem", border: "1px solid #ccc", borderRadius: 6 }}>
      <div style={{ marginBottom: 8 }}>
        <strong>📅 Daily:</strong> {usage.today}/{usage.dailyLimit}
        <div style={{ height: 6, background: "#eee", borderRadius: 4, marginTop: 4 }}>
          <div style={{ width: `${dailyPct}%`, height: "100%", background: dailyPct >= 100 ? "#f44336" : "#4caf50", borderRadius: 4 }}></div>
        </div>
      </div>
      {/* <div>
        <strong>📆 Weekly:</strong> {usage.week}/{usage.weeklyLimit}
        <div style={{ height: 6, background: "#eee", borderRadius: 4, marginTop: 4 }}>
          <div style={{ width: `${weeklyPct}%`, height: "100%", background: weeklyPct >= 100 ? "#f44336" : "#2196f3", borderRadius: 4 }}></div>
        </div>
      </div> */}
      {overLimit && isAnonymous && (
        <div style={{ color: "#d32f2f", marginTop: "0.5rem" }}>
          ⚠️ You’ve reached your free daily usage limit. FREE Sign up for unlimited swaps.
        </div>
      )}
    </div>
  );
};

export default UsageDashboard;
